import { makeStyles } from '@material-ui/core/styles'

import { FONTS } from 'styles'

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: theme.palette.primary.main,
    height: 120,
  },
  appBarLoggedIn: {
    [theme.breakpoints.down('sm')]: {
      height: 150,
    },
  },
  toolbar: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  backButton: {
    padding: 0,
    minWidth: 30,
    minHeight: 30,
  },
  backIcon: {
    stroke: theme.palette.background.default,
  },
  questionIcon: {
    stroke: theme.palette.primary.contrastText,
    fill: theme.palette.primary.contrastText,
  },
  title: {
    color: theme.palette.primary.contrastText,
    fontFamily: FONTS.POPPINS_SEMI_BOLD,
    fontSize: '1rem',
  },
  logoArea: {
    position: 'absolute',
    top: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    pointerEvents: 'none',
  },
  logoAreaLoggedIn: {
    [theme.breakpoints.down('sm')]: {
      height: '50%',
    },
  },
  logoContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: 50,
    width: 400,
  },
  logo: {
    fill: `${theme.palette.background.default} !important`,
    maxHeight: 50,
    maxWidth: '90vw',
    marginBottom: 5,
    [theme.breakpoints.down('sm')]: {
      marginRight: 20,
      marginLeft: 20,
    },
  },
  logout: {
    marginLeft: 'auto',
    color: theme.palette.background.default,
    fontFamily: FONTS.GOTHAM_MEDIUM,
    fontSize: '14px',
    [theme.breakpoints.down('md')]: {},
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  },
  storeName: {
    pointerEvents: 'none',
    marginRight: 'auto',
    color: theme.palette.background.default,
    fontFamily: FONTS.GOTHAM_MEDIUM,
    fontSize: '14px',
    textTransform: 'uppercase',
    [theme.breakpoints.down('md')]: {},
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  },
  leftArea: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      marginTop: 60,
    },
  },
  rightArea: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      marginTop: 60,
    },
  },
}))

export { useStyles }
